import EventEditParent from '@/screens/EventEditParent';

export default function PrivateEventEventIdEditParentRoute() {
  return <EventEditParent />;
}
